module.exports = {"classes":["legal-page","header-dark"],"title":"Legal","metas":{"description":"Legal Information."},"opengraph":{"og:title":"Legal","og:description":"Legal Information.","og:url":"https://auth0.com/legal"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/legal/metadata.json
// module id = 1650
// module chunks = 0